module.exports = ['$scope', 'CanDoServices', 'ngDroUAA', 'ngDroUtilsNotify', '$state',
    function ($scope, CanDoServices, ngDroUAA, ngDroUtilsNotify, $state) {

        // Informazioni per la parametrizzazione della direttiva button-add.
        $scope.infoAdd = {icon: 'fa-inbox', message: 'jdro_template.add'};
        /*
         * Init
         */

        // Ottengo i permessi per le operazioni Create, Update, Delete dei template        
        CanDoServices.canDo("TEMPLATE").then(function (perms) {
            $scope.jdroPerms = perms;
        });
        // Caricamento dei Gruppi al caricamento della pagina.
        loadTemplates();
        /*
         * Methods
         */
        function loadTemplates() {
            ngDroUAA.Template.findAll()
                    .then(function (response) {
                        $scope.templates = response.data;
                    })
                    .catch(function (err) {
                        ngDroUtilsNotify.error(null, 'jdro_template.error.find_all', null,err);
                    });
        }

        $scope.remove = function (template) {
            if (!template.id) {
                loadTemplates();
                return;
            }
            options = {
                success: function () {
                    ngDroUAA.Template.delete(template.id)
                            .then(function () {
                                ngDroUtilsNotify.deleteSuccess(template.code);
                                loadTemplates();
                            })
                            .catch(function (error) {
                                ngDroUtilsNotify.deleteError(error);
                            });
                },
                itemTitle: template.code,
                headTitle: 'jdro_template.confirm_delete'
            };
            ngDroUtilsNotify.confirmDelete(options);
        };
        $scope.add = function () {
            $state.go('uaa-module-template-add');
        };
        $scope.edit = function (item) {
            $state.go('uaa-module-template-edit', {id: item.id});
        };
    }];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/components/template/templateList/templateListCtrl.js
// module id = 416
// module chunks = 0